import script from "./People.vue?vue&type=script&setup=true&lang=ts"
export * from "./People.vue?vue&type=script&setup=true&lang=ts"

import "./People.vue?vue&type=style&index=0&id=110af4d1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110af4d1"]])

export default __exports__